import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';

import { snDetailExpand, snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnTableBaseComponent } from 'libs/core/src/lib/components/table-base.component';

import { FsWhoosterAddressModel } from '../../models/whooster-address.model';

@Component({
  selector: 'sn-whooster-address-table',
  templateUrl: './whooster-address-table.component.html',
  styleUrls: ['./whooster-address-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut, snDetailExpand],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FsWhoosterAddressTableComponent
  extends SnTableBaseComponent<FsWhoosterAddressModel>
  implements OnInit
{
  public tableItems: FsWhoosterAddressModel[];

  private _expanded = [];

  @Output() public readonly whoosterDownload = new EventEmitter<String>();

  constructor(private readonly _cd: ChangeDetectorRef) {
    super();
  }

  public isExpanded(id: string): boolean {
    return this._expanded.indexOf(id) > -1;
  }

  public toggleExpanded(item: any): void {
    if (this.isExpanded(item.uuid)) {
      this._expanded = [];
    } else {
      this._expanded = [item.uuid];
      this._cd.detectChanges();
    }
  }

  public whoosterPdf(item: any): void {
    this.whoosterDownload.next(item.uuid);
  }

  public ngOnInit(): void {
    if (this.hasThree()) {
      this.threeItems();
    } else {
      this.allItems();
    }
  }

  public threeItems(): void {
    this.tableItems = this.items.slice(0, 3);
  }

  public allItems(): void {
    this.tableItems = this.items;
  }

  public hasThree(): boolean {
    return this.items.length > 3;
  }

  public lessToggle(): boolean {
    return this.tableItems.length > 3;
  }

  public trackBy(index: number, item: FsWhoosterAddressModel): string {
    return item.uuid;
  }
}
